import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import {
  IFlightOperator,
  IFlightOperatorForm,
} from 'src/models/flight-operator.model';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import Lang from 'src/libraries/language';
import { getFlightOperatorStatus } from 'src/selectors/flight-operator.selector';
import { actionTypes } from 'src/ducks/flight-operator.duck';
import FlightOperatorsForm from '../flight-operators-form/flight-operators-form.component';
import style from '../flight-operators-list/flight-operators-list.module.scss';

type IProp = {
  data: IFlightOperator;
};

const FlightOperatorsEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFlightOperatorContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IFlightOperator> = {
    name: '',
    email: '',
    operatorId: 0,
    activeFlag: true,
    dispatchFlag: true,
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getFlightOperatorStatus(
    state,
    actionTypes.FLIGHT_OPERATOR_UPDATE
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IFlightOperatorForm = {
        name: value.name,
        email: value.email,
        activeFlag: value.activeFlag,
        dispatchFlag: value.dispatchFlag,
      };
      const response = await actions.updatePUT(value.operatorId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FLIGHT_OPERATOR_EDIT_SUCCESS,
            formData.name ? formData.name : value.name
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => {
            setIsEditOpen(true);
          }}
        />
      }
      header={Lang.LBL_MODIFY_FLIGHT_OPERATOR}
      content={
        <div className={style.content}>
          <FlightOperatorsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightOperatorsEdit;
